import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Page from '../../common/page/Page';
import { EntityTerminationDetailPage } from '..';
import MonitoringQueueListPage from '../MonitoringQueueListPage';
import EntityTerminationActionItemPage from '../actionItems/EntityTerminationActionItemPage';
import EntityTerminationBlockerDetailPage from '../blocker/EntityTerminationBlockerDetailPage';
import {
  GET_LEGAL_IN_PROCESS_ACTION_ITEM,
  UPDATE_LEGAL_IN_PROCESS_ACTION_ITEM,
  CREATE_LEGAL_IN_PROCESS_ACTION_ITEM_TASK,
  UPDATE_LEGAL_IN_PROCESS_ACTION_ITEM_TASK,
  GET_FINANCE_INCOMPLETE_ACTION_ITEM,
  UPDATE_FINANCE_INCOMPLETE_ACTION_ITEM,
  CREATE_FINANCE_INCOMPLETE_ACTION_ITEM_TASK,
  UPDATE_FINANCE_INCOMPLETE_ACTION_ITEM_TASK,
} from '../../../utils/statApi/EntityTerminationApi';
import { EntityTerminationUriSegment } from '../types';

const MonitoringQueueRoute: React.FunctionComponent = () => {
  return (
    <Switch>
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}`}
        exact
        render={() => (
          <Page title="Legal Entity Terminations">
            <MonitoringQueueListPage />
          </Page>
        )}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.Overview}`}
        component={() => <EntityTerminationDetailPage baseRoute="monitoring-queue" />}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.EligibilityReview}`}
        component={() => <EntityTerminationDetailPage baseRoute="monitoring-queue" />}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.Blocker}/actionItem/:actionItemId`}
        component={() => <EntityTerminationBlockerDetailPage />}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.Blocker}`}
        component={() => <EntityTerminationDetailPage baseRoute="monitoring-queue" />}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.LegalInProcess}/actionItem/:actionItemId`}
        component={() => (
          <EntityTerminationActionItemPage
            callerUrl={EntityTerminationUriSegment.LegalInProcess}
            query={GET_LEGAL_IN_PROCESS_ACTION_ITEM}
            updateActionItemMutation={UPDATE_LEGAL_IN_PROCESS_ACTION_ITEM}
            dtoVariableName="legalInProcessActionItemDto"
            editAction="LegalInProcess:Edit"
            createTaskMutation={CREATE_LEGAL_IN_PROCESS_ACTION_ITEM_TASK}
            updateTaskMutation={UPDATE_LEGAL_IN_PROCESS_ACTION_ITEM_TASK}
          />
        )}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.LegalInProcess}`}
        component={() => <EntityTerminationDetailPage baseRoute="monitoring-queue" />}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.FinanceIncomplete}/actionItem/:actionItemId`}
        component={() => (
          <EntityTerminationActionItemPage
            callerUrl={EntityTerminationUriSegment.FinanceIncomplete}
            query={GET_FINANCE_INCOMPLETE_ACTION_ITEM}
            updateActionItemMutation={UPDATE_FINANCE_INCOMPLETE_ACTION_ITEM}
            dtoVariableName="financeIncompleteActionItemDto"
            editAction="EntityTerminationFinanceIncomplete:Edit"
            isDescriptionReadOnly
            includeCompanyCodeInQuery
            createTaskMutation={CREATE_FINANCE_INCOMPLETE_ACTION_ITEM_TASK}
            updateTaskMutation={UPDATE_FINANCE_INCOMPLETE_ACTION_ITEM_TASK}
            taskDtoVariableName="financeIncompleteTaskDto"
            actionItemIdFieldName="financeIncompleteActionItemId"
            enableTaskDocuments
          />
        )}
      />
      <Route
        path={`/${EntityTerminationUriSegment.MonitoringQueue}/:companyCode/${EntityTerminationUriSegment.FinanceIncomplete}`}
        component={() => <EntityTerminationDetailPage baseRoute="monitoring-queue" />}
      />
    </Switch>
  );
};

export default MonitoringQueueRoute;
